/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, delegateRemove, enumGetBox, delegateCombine } from "igniteui-react-core";
import { XInputGroup } from "./XInputGroup";
import { XLabel } from "./XLabel";
import { XInput } from "./XInput";
import { XSuffix } from "./XSuffix";
import { XIcon } from "./XIcon";
import { Popup } from "igniteui-react-layouts";
import { Calendar } from "./Calendar";
import { SRProvider } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { DayOfWeek_$type } from "./DayOfWeek";
import { FirstWeek_$type } from "./FirstWeek";
import { DateFormats_$type } from "./DateFormats";
import { BrushUtil } from "igniteui-react-core";
import { DateTimeValueFormatter } from "./DateTimeValueFormatter";
import { ValueChangedEventArgs } from "./ValueChangedEventArgs";
import { GotFocusEventArgs } from "./GotFocusEventArgs";
import { LostFocusEventArgs } from "./LostFocusEventArgs";
import { DatePickerVisualModelExport } from "./DatePickerVisualModelExport";
import { FontUtil } from "igniteui-react-core";
import { dateMinValue, dateMaxValue, dateGetDate, dateFromValues, dateGetMonth } from "igniteui-react-core";
import { stringContains, stringIsNullOrWhiteSpace } from "igniteui-react-core";
import { stringSplit } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var DatePickerView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(DatePickerView, _super);
    function DatePickerView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.c = null;
        _this.j = null;
        _this.d = null;
        _this.l = null;
        _this.k = null;
        _this.i = null;
        _this.f = null;
        _this.e = null;
        _this.h = null;
        _this.g = null;
        return _this;
    }
    DatePickerView.prototype.ae = function () {
    };
    DatePickerView.prototype.ad = function (a) {
        if (a == null) {
            this.c = null;
            return;
        }
        this.c = a;
        var b = Math.round(a.rootWrapper.width());
        var c = Math.round(a.rootWrapper.height());
        this.x();
        this.y();
        var d = this.c.rootWrapper.getChildAt(0);
        d.listen("keydown", runOn(this, this.v));
        d.listen("focusin", runOn(this, this.t));
        d.listen("focusout", runOn(this, this.u));
        document.addEventListener("click", runOn(this, this.z), false);
    };
    DatePickerView.prototype.x = function () {
        if (this.c != null) {
            this.j = this.c.rootWrapper.getChildAt(0);
            this.j.setAttribute("tabIndex", "0");
            this.j.setStyleProperty("display", "flex");
            this.j.setStyleProperty("height", "100%");
            this.k = this.c.createElement("div");
            this.i = this.c.createElement("div");
            this.i.setRawStyleProperty("flex-grow", "1");
            this.f = this.c.createElement("div");
            this.f.setAttribute("aria-hidden", "true");
            this.e = this.c.createElement("div");
            this.h = this.c.createElement("div");
            this.h.setAttribute("aria-hidden", "true");
            this.g = this.c.createElement("div");
            this.a.cd();
            this.i.getChildAt(0).setAttribute("aria-expanded", "fasle");
            this.i.getChildAt(0).setAttribute("aria-invalid", "false");
            this.e.setStyleProperty("height", "16px");
            this.e.setStyleProperty("width", "16px");
            this.g.setStyleProperty("height", "16px");
            this.g.setStyleProperty("width", "16px");
            this.e.listen("click", runOn(this, this.w));
            this.g.listen("click", runOn(this, this.aa));
        }
    };
    DatePickerView.prototype.ah = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.j);
            a.provideContainer(b);
            var c = this.c.getExternal(a, b.rootWrapper, this.c.getExternal(this.a, null, null));
        }
    };
    DatePickerView.prototype.aj = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.k);
            a.provideContainer(b);
            var c = this.c.getExternal(a, b.rootWrapper, this.c.getExternal(this.a, null, null));
        }
    };
    DatePickerView.prototype.ai = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.i);
            a.provideContainer(b);
            var c = this.c.getExternal(a, b.rootWrapper, this.c.getExternal(this.a, null, null));
        }
    };
    DatePickerView.prototype.al = function (a, b) {
        if (this.c != null) {
            var c = this.c.getSubRenderer(b);
            a.provideContainer(c);
            var d = this.c.getExternal(a, c.rootWrapper, this.c.getExternal(this.a, null, null));
        }
    };
    DatePickerView.prototype.ag = function (a, b) {
        if (this.c != null) {
            var c = this.c.getSubRenderer(b);
            a.provideContainer(c);
            var d = this.c.getExternal(a, c.rootWrapper, this.c.getExternal(this.a, null, null));
        }
    };
    DatePickerView.prototype.s = function () {
        return this.k;
    };
    DatePickerView.prototype.r = function () {
        return this.i;
    };
    DatePickerView.prototype.o = function () {
        return this.f;
    };
    DatePickerView.prototype.n = function () {
        return this.e;
    };
    DatePickerView.prototype.q = function () {
        return this.h;
    };
    DatePickerView.prototype.p = function () {
        return this.g;
    };
    DatePickerView.prototype.an = function (a) {
        if (this.i != null) {
            if (a) {
                this.i.getChildAt(0).setAttribute("aria-expanded", "true");
            }
            else {
                this.i.getChildAt(0).setAttribute("aria-expanded", "false");
            }
        }
    };
    DatePickerView.prototype.ao = function (a) {
        if (a != null && a != "") {
            this.i.getChildAt(0).setAttribute("aria-label", a);
        }
        else {
            this.i.getChildAt(0).setAttribute("aria-label", "Select a date");
        }
    };
    DatePickerView.prototype.am = function () {
        if (this.e != null) {
            if (this.a.as == true) {
                this.e.show();
            }
            else {
                this.e.hide();
            }
        }
    };
    DatePickerView.prototype.ab = function () {
        if (this.e != null) {
            this.e.hide();
        }
    };
    DatePickerView.prototype.y = function () {
        if (this.c != null) {
            this.l = this.c.rootWrapper.getChildAt(1);
            this.d = this.c.createElement("div");
            this.d.setStyleProperty("width", "100%");
            this.d.setStyleProperty("height", "100%");
            this.d.setStyleProperty("display", "flex");
            this.a.ce();
            this.d.parent().setStyleProperty("height", "100%");
        }
    };
    DatePickerView.prototype.ak = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.l);
            a.provideRenderer(b);
            var c = b.getExternal(a, b.rootWrapper, b.getExternal(this.a, null, null));
        }
    };
    DatePickerView.prototype.af = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.d);
            a.provideContainer(b);
            var c = this.c.getExternal(a, b.rootWrapper, this.c.getExternal(this.a, null, null));
        }
    };
    DatePickerView.prototype.m = function () {
        return this.d;
    };
    DatePickerView.prototype.w = function (a) {
        this.a.cb();
        if (this.e != null) {
            this.e.hide();
        }
    };
    DatePickerView.prototype.aa = function (a) {
        a.stopPropagation();
        this.a.cj();
    };
    DatePickerView.prototype.v = function (a) {
        var b = a.which;
        if (b == 27) {
            this.a.cc();
        }
    };
    DatePickerView.prototype.t = function (a) {
        this.a.focus();
        var b = (a.originalEvent.relatedTarget);
        if (!this.b(b)) {
            this.a.cp();
        }
    };
    DatePickerView.prototype.u = function (a) {
        var b = (a.originalEvent.relatedTarget);
        if (!this.b(b)) {
            this.a.ci();
            this.a.cq();
        }
    };
    DatePickerView.prototype.z = function (a) {
        var b = a.target;
        if (!this.b(b)) {
            this.a.cc();
        }
    };
    DatePickerView.prototype.ap = function () {
        if (this.c != null) {
            var a = this.c.rootWrapper.getNativeElement();
            var b = a.getBoundingClientRect();
            ;
            return b;
        }
        return null;
    };
    DatePickerView.prototype.b = function (a) {
        if (null == a) {
            return false;
        }
        var b = this.i.getNativeElement();
        var c = this.d.getNativeElement();
        return b.contains(a) || c.contains(a);
    };
    DatePickerView.prototype.ac = function () {
    };
    DatePickerView.$t = markType(DatePickerView, 'DatePickerView');
    return DatePickerView;
}(Base));
export { DatePickerView };
/**
 * @hidden
 */
var DatePicker = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super.call(this) || this;
        _this.l = null;
        _this.y = null;
        _this.u = null;
        _this.s = null;
        _this.v = null;
        _this.q = null;
        _this.r = null;
        _this.g = null;
        _this.a6 = "dd";
        _this.ba = "mm";
        _this.bd = "yyyy";
        _this.a7 = "mdy";
        _this.bc = "/";
        _this.ah = false;
        _this.ao = false;
        _this.an = false;
        _this.ax = dateMinValue();
        _this.propertyChanged = null;
        _this.valueChanged = null;
        _this.ae = null;
        _this.az = dateMinValue();
        _this.ay = dateMinValue();
        _this.a9 = "";
        _this.c9 = BrushUtil.g(255, 24, 29, 31);
        _this.z = null;
        _this.bb = "";
        _this.aw = dateMinValue();
        _this.av = dateMaxValue();
        _this.c = 2;
        _this.a = 1;
        _this.aa = null;
        _this.da = BrushUtil.g(255, 24, 29, 31);
        _this.c8 = BrushUtil.g(255, 163, 172, 184);
        _this.ak = true;
        _this.al = false;
        _this.ag = true;
        _this.aj = true;
        _this.m = 0;
        _this.o = 0;
        _this.am = false;
        _this.e = new DateTimeValueFormatter();
        _this.h = 0;
        _this.a8 = null;
        _this.ai = false;
        _this.gotFocus = null;
        _this.lostFocus = null;
        _this.keyDown = null;
        _this.changing = null;
        var a = new DatePickerView();
        a.a = _this;
        _this.l = a;
        _this.l.ae();
        _this.ca();
        return _this;
    }
    DatePicker.prototype.cv = function (a, b) {
        if (this.y != null) {
            this.ah = true;
            this.cc();
        }
        this.c3();
        if (this.valueChanged != null) {
            this.valueChanged(this, ((function () {
                var $ret = new ValueChangedEventArgs();
                $ret.oldValue = a;
                $ret.newValue = b;
                return $ret;
            })()));
        }
        this.cz();
    };
    DatePicker.prototype.notifySizeChanged = function () {
        this.l.ac();
    };
    DatePicker.prototype.destroy = function () {
        if (this.g != null) {
            var a = this.g;
            a.valueChanged = delegateRemove(a.valueChanged, runOn(this, this.b9));
            var b = this.g;
            b.close = delegateRemove(b.close, runOn(this, this.b8));
        }
        this.provideContainer(null);
    };
    DatePicker.prototype.provideContainer = function (a) {
        this.l.ad(a);
    };
    Object.defineProperty(DatePicker.prototype, "af", {
        get: function () {
            if (this.ae == null) {
                this.ae = new SRProvider(this.l.c);
                this.ae.cb("Calendar");
            }
            return this.ae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "a3", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.ax = b;
            this.az = a;
            if (+b != +(this.az)) {
                this.cu("Value", b, this.az);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "a2", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (+b != +(this.ay)) {
                this.cu("Today", b, this.ay);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "bs", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            if (b != this.a9) {
                this.cu("Label", b, this.a9);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "dc", {
        get: function () {
            return this.c9;
        },
        set: function (a) {
            var b = this.c9;
            this.c9 = a;
            if (b != this.c9) {
                this.cu("LabelTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ac", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.cu("LabelTextStyle", b, this.z);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "bz", {
        get: function () {
            return this.bb;
        },
        set: function (a) {
            var b = this.bb;
            this.bb = a;
            if (b != this.bb) {
                this.cu("Placeholder", b, this.bb);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "a1", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (+b != +(this.aw)) {
                this.cu("MinDate", b, this.aw);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "a0", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            if (+b != +(this.av)) {
                this.cu("MaxDate", b, this.av);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.cu("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, this.c));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.cu("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, this.a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ad", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            var b = this.aa;
            this.aa = a;
            if (b != this.aa) {
                this.cu("TextStyle", b, this.aa);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "dd", {
        get: function () {
            return this.da;
        },
        set: function (a) {
            var b = this.da;
            this.da = a;
            if (b != this.da) {
                this.cu("TextColor", b, this.da);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "db", {
        get: function () {
            return this.c8;
        },
        set: function (a) {
            var b = this.c8;
            this.c8 = a;
            if (b != this.c8) {
                this.cu("IconColor", b, this.c8);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "as", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            if (b != this.ak) {
                this.cu("ShowClearButton", b, this.ak);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "at", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (b != this.al) {
                this.cu("ShowTodayButton", b, this.al);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ap", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (b != this.ag) {
                this.cu("AllowTextInput", b, this.ag);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ar", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            var b = this.aj;
            this.aj = a;
            if (b != this.aj) {
                this.cu("OpenOnFocus", b, this.aj);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "n", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.cu("FirstDayOfWeek", enumGetBox(DayOfWeek_$type, b), enumGetBox(DayOfWeek_$type, this.m));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "p", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            var b = this.o;
            this.o = a;
            if (b != this.o) {
                this.cu("FirstWeekOfYear", enumGetBox(FirstWeek_$type, b), enumGetBox(FirstWeek_$type, this.o));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "au", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (b != this.am) {
                this.cu("ShowWeekNumbers", b, this.am);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "i", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            var b = this.h;
            this.h = a;
            if (this.h != b) {
                this.cu("DateFormat", enumGetBox(DateFormats_$type, b), enumGetBox(DateFormats_$type, this.h));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "bo", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (b != this.a8) {
                this.cu("FormatString", b, this.a8);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "aq", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (b != this.ai) {
                this.cu("IsDisabled", b, this.ai);
            }
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.cu = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.cx(a, b, c);
    };
    DatePicker.prototype.cx = function (a, b, c) {
        switch (a) {
            case "Density":
                this.c0();
                break;
            case "BaseTheme":
                this.c1();
                break;
            case "Value":
                if (+(this.a3) != +(dateMinValue())) {
                    if (dateGetDate(this.a3) < dateGetDate(this.a1) || dateGetDate(this.a3) > dateGetDate(this.a0)) {
                        this.a3 = this.ax;
                    }
                }
                this.cv(this.ax, this.a3);
                this.ax = this.a3;
                if (this.g != null) {
                    this.g.aw = this.a3;
                }
                break;
            case "Label":
                if (this.v != null) {
                    this.v.text = this.bs;
                    if (this.bs != null && this.bs != "") {
                        if (!this.u.inputs.contains(this.v)) {
                            this.u.inputs.insert(0, this.v);
                        }
                    }
                    else {
                        if (this.u.inputs.contains(this.v)) {
                            this.u.inputs.remove(this.v);
                        }
                    }
                }
                break;
            case "Placeholder":
                if (this.s != null) {
                    this.s.cb = this.bz;
                    this.l.ao(this.bz);
                }
                break;
            case "Today":
                if (this.g != null) {
                    this.g.av = this.a2;
                }
                break;
            case "MaxDate":
                if (this.g != null) {
                    var d = Base.compareSimple(this.a1, this.a0);
                    if (d >= 0) {
                        this.a0 = dateMaxValue();
                    }
                    this.g.at = this.av;
                }
                if (dateGetDate(this.a3) > dateGetDate(this.a0)) {
                    this.ax = dateMinValue();
                    this.a3 = dateMinValue();
                }
                break;
            case "MinDate":
                if (this.g != null) {
                    this.g.au = this.aw;
                    var e = Base.compareSimple(this.a1, this.a0);
                    if (e >= 0) {
                        this.ax = dateMaxValue();
                        this.g.at = this.a0;
                    }
                }
                if (dateGetDate(this.a3) < dateGetDate(this.a1)) {
                    this.ax = dateMinValue();
                    this.a3 = dateMinValue();
                }
                break;
            case "TextStyle":
                this.c4();
                break;
            case "ShowClearButton":
                if (this.s != null) {
                    if (this.s.cj != "") {
                        this.l.am();
                    }
                }
                break;
            case "LabelTextColor":
            case "LabelTextStyle":
            case "TextColor":
            case "IconColor":
                this.c5();
                break;
            case "ShowTodayButton":
                if (this.g != null) {
                    this.g.ae = this.at;
                }
                break;
            case "AllowTextInput":
                if (this.s != null) {
                    this.s.disabled = !this.ap;
                }
                break;
            case "OpenOnFocus": break;
            case "DateFormat":
                this.e.k(this.i);
                this.c3();
                break;
            case "FormatString":
                this.ca();
                this.c3();
                break;
            case "FirstDayOfWeek":
                if (this.g != null) {
                    this.g.p = this.n;
                }
                break;
            case "ShowWeekNumbers":
                if (this.g != null) {
                    this.g.af = this.au;
                }
                break;
            case "FirstWeekOfYear":
                if (this.g != null) {
                    this.g.s = this.p;
                }
                break;
            case "IsDisabled":
                {
                    if (this.u != null) {
                        this.u.disabled = this.aq;
                    }
                    if (this.s != null) {
                        this.s.disabled = this.aq;
                    }
                }
                break;
        }
    };
    DatePicker.prototype.ca = function () {
        var a = '/';
        var b = this.bo != null ? this.bo.toLowerCase() : this.e.j();
        if (stringContains(b, "/")) {
            a = '/';
        }
        else if (stringContains(b, "-")) {
            a = '-';
        }
        else if (stringContains(b, " ")) {
            a = ' ';
        }
        else if (stringContains(b, ".")) {
            a = '.';
        }
        else if (stringContains(b, ",")) {
            a = ',';
        }
        this.bc = a.toString();
        var c = b.split(a);
        if (c.length == 3) {
            var d = "";
            for (var e = 0; e < 3; e++) {
                if (stringContains(c[e], "d")) {
                    d += "d";
                    switch (c[e]) {
                        case "d":
                            this.a6 = c[e];
                            break;
                        case "dd":
                            this.a6 = c[e];
                            break;
                        case "ddd":
                            this.a6 = c[e];
                            break;
                        case "dddd":
                            this.a6 = c[e];
                            break;
                        default:
                            this.a6 = "dd";
                            break;
                    }
                }
                else if (stringContains(c[e], "m")) {
                    d += "m";
                    switch (c[e]) {
                        case "m":
                            this.ba = c[e];
                            break;
                        case "mm":
                            this.ba = c[e];
                            break;
                        case "mmm":
                            this.ba = c[e];
                            break;
                        case "mmmm":
                            this.ba = c[e];
                            break;
                        default:
                            this.ba = "mm";
                            break;
                    }
                    this.ba = c[e];
                }
                else if (stringContains(c[e], "y")) {
                    d += "y";
                    switch (c[e]) {
                        case "yy":
                            this.bd = c[e];
                            break;
                        case "yyyy":
                            this.bd = c[e];
                            break;
                        default:
                            this.bd = "yyyy";
                            break;
                    }
                }
            }
            if (d == "dmy" || d == "mdy" || d == "ymd") {
                this.a7 = d;
            }
            else {
                this.a7 = "mdy";
            }
        }
    };
    DatePicker.prototype.c5 = function () {
        if (this.s != null) {
            this.s.dy = this.dd;
        }
        if (this.q != null) {
            this.q.fill = this.db;
        }
        if (this.r != null) {
            this.r.fill = this.db;
        }
        if (this.v != null) {
            this.v.df = this.dc;
            this.v.y = this.ac;
        }
    };
    DatePicker.prototype.c2 = function () {
        if (this.u != null) {
        }
    };
    DatePicker.prototype.c4 = function () {
        if (this.aa != null) {
            this.s.ac = this.aa;
        }
    };
    DatePicker.prototype.cd = function () {
        this.u = new XInputGroup();
        this.l.ah(this.u);
        this.u.k = 0;
        this.u.d = this.b;
        this.u.h = this.d;
        this.v = new XLabel();
        this.l.aj(this.v);
        this.v.df = this.dc;
        this.v.y = this.ac;
        this.u.appendContentChild(this.l.s());
        if (this.bs != null && this.bs != "") {
            this.v.text = this.bs;
            this.u.inputs.add(this.v);
        }
        this.s = new XInput();
        this.l.ai(this.s);
        this.s.b3 = "text";
        if (this.aa != null) {
            this.s.ac = this.aa;
        }
        this.s.disabled = !this.ap;
        this.s.dy = this.dd;
        this.u.appendContentChild(this.l.r());
        this.u.inputs.add(this.s);
        this.s.cb = this.bz;
        this.l.ao(this.bz);
        var a = this.s;
        a.change = delegateCombine(a.change, runOn(this, this.ck));
        var b = this.s;
        b.changing = delegateCombine(b.changing, runOn(this, this.cl));
        var c = this.s;
        c.keyDown = delegateCombine(c.keyDown, runOn(this, this.cm));
        var d = new XSuffix();
        this.l.al(d, this.l.o());
        this.q = new XIcon();
        this.l.ag(this.q, this.l.n());
        this.q.svgPath = DatePicker.bh;
        this.q.fill = this.db;
        d.appendContentChild(this.l.n());
        this.u.appendContentChild(this.l.o());
        this.u.inputs.add(d);
        this.c3();
        var e = new XSuffix();
        this.l.al(e, this.l.q());
        this.r = new XIcon();
        this.l.ag(this.r, this.l.p());
        this.r.svgPath = DatePicker.bg;
        this.r.fill = this.db;
        e.appendContentChild(this.l.p());
        this.u.appendContentChild(this.l.q());
        this.u.inputs.add(e);
    };
    DatePicker.prototype.cm = function (a, b) {
        this.cs(b);
        if (b.defaultPrevented) {
            return;
        }
        var c = b.keyCode;
        var d = b.modifiers;
        switch (c) {
            case 9:
                this.an = true;
                if (!this.ao) {
                    this.c7(this.s.cj);
                }
                this.ah = true;
                this.cc();
                this.an = false;
                break;
            case 13:
                this.an = true;
                if (!this.ao) {
                    this.c7(this.s.cj);
                }
                this.ah = true;
                this.cc();
                this.an = false;
                break;
            case 40:
                if (d == 1) {
                    this.cw();
                    this.ch();
                }
                break;
            case 38:
                if (d == 1) {
                    this.cc();
                }
                break;
        }
    };
    DatePicker.prototype.cl = function (a, b) {
        this.co(b);
        if (b.value.length > 0) {
            this.l.am();
        }
        else {
            this.l.ab();
        }
    };
    DatePicker.prototype.ck = function (a, b) {
        this.ao = true;
        this.c7(b.value);
        this.ao = false;
    };
    DatePicker.prototype.c7 = function (a) {
        var b = ['/', '-', ' ', '.', ','];
        var c = stringSplit(a, b, 1);
        var d = 0;
        var e = 0;
        var f = 0;
        var g = true;
        if (c.length == 3) {
            if (c[0].length == 0 || c[1].length == 0 || c[2].length == 0) {
                g = false;
            }
            if (this.a7 == "dmy") {
                d = parseInt(c[0]);
                e = parseInt(c[1]);
                f = parseInt(c[2]);
            }
            else if (this.a7 == "mdy") {
                e = parseInt(c[0]);
                d = parseInt(c[1]);
                f = parseInt(c[2]);
            }
            else if (this.a7 == "ymd") {
                f = parseInt(c[0]);
                e = parseInt(c[1]);
                d = parseInt(c[2]);
            }
            if (isNaN_(d) || isNaN_(f)) {
                g = false;
            }
            if (f < 50) {
                f = f + 2000;
            }
            if (isNaN_(e)) {
                var h = "";
                if (this.a7 == "dmy") {
                    h = c[1].toLowerCase();
                }
                else if (this.a7 == "mdy") {
                    h = c[0].toLowerCase();
                }
                else if (this.a7 == "ymd") {
                    h = c[1].toLowerCase();
                }
                var i = !stringIsNullOrWhiteSpace(this.af.b1("January_Full")) ? this.af.b1("January_Full").toLowerCase() : "january";
                var j = !stringIsNullOrWhiteSpace(this.af.b1("January_Short")) ? this.af.b1("January_Short").toLowerCase() : "jan";
                var k = !stringIsNullOrWhiteSpace(this.af.b1("February_Full")) ? this.af.b1("February_Full").toLowerCase() : "february";
                var l = !stringIsNullOrWhiteSpace(this.af.b1("February_Short")) ? this.af.b1("February_Short").toLowerCase() : "feb";
                var m = !stringIsNullOrWhiteSpace(this.af.b1("March_Full")) ? this.af.b1("March_Full").toLowerCase() : "march";
                var n = !stringIsNullOrWhiteSpace(this.af.b1("March_Short")) ? this.af.b1("March_Short").toLowerCase() : "mar";
                var o = !stringIsNullOrWhiteSpace(this.af.b1("April_Full")) ? this.af.b1("April_Full").toLowerCase() : "april";
                var p = !stringIsNullOrWhiteSpace(this.af.b1("April_Short")) ? this.af.b1("April_Short").toLowerCase() : "apr";
                var q = !stringIsNullOrWhiteSpace(this.af.b1("May_Full")) ? this.af.b1("May_Full").toLowerCase() : "may";
                var r = !stringIsNullOrWhiteSpace(this.af.b1("May_Short")) ? this.af.b1("May_Short").toLowerCase() : "may";
                var s = !stringIsNullOrWhiteSpace(this.af.b1("June_Full")) ? this.af.b1("June_Full").toLowerCase() : "june";
                var t = !stringIsNullOrWhiteSpace(this.af.b1("June_Short")) ? this.af.b1("June_Short").toLowerCase() : "jun";
                var u = !stringIsNullOrWhiteSpace(this.af.b1("July_Full")) ? this.af.b1("July_Full").toLowerCase() : "july";
                var v = !stringIsNullOrWhiteSpace(this.af.b1("July_Short")) ? this.af.b1("July_Short").toLowerCase() : "jul";
                var w = !stringIsNullOrWhiteSpace(this.af.b1("August_Full")) ? this.af.b1("August_Full").toLowerCase() : "august";
                var x = !stringIsNullOrWhiteSpace(this.af.b1("August_Short")) ? this.af.b1("August_Short").toLowerCase() : "aug";
                var y = !stringIsNullOrWhiteSpace(this.af.b1("September_Full")) ? this.af.b1("September_Full").toLowerCase() : "september";
                var z = !stringIsNullOrWhiteSpace(this.af.b1("September_Short")) ? this.af.b1("September_Short").toLowerCase() : "sep";
                var aa = !stringIsNullOrWhiteSpace(this.af.b1("October_Full")) ? this.af.b1("October_Full").toLowerCase() : "october";
                var ab = !stringIsNullOrWhiteSpace(this.af.b1("October_Short")) ? this.af.b1("October_Short").toLowerCase() : "oct";
                var ac = !stringIsNullOrWhiteSpace(this.af.b1("November_Full")) ? this.af.b1("November_Full").toLowerCase() : "november";
                var ad = !stringIsNullOrWhiteSpace(this.af.b1("November_Short")) ? this.af.b1("November_Short").toLowerCase() : "nov";
                var ae = !stringIsNullOrWhiteSpace(this.af.b1("December_Full")) ? this.af.b1("December_Full").toLowerCase() : "december";
                var af = !stringIsNullOrWhiteSpace(this.af.b1("December_Short")) ? this.af.b1("December_Short").toLowerCase() : "dec";
                if (h == i || h == j) {
                    e = 1;
                }
                else if (h == k || h == l) {
                    e = 2;
                }
                else if (h == m || h == n) {
                    e = 3;
                }
                else if (h == o || h == p) {
                    e = 4;
                }
                else if (h == q || h == r) {
                    e = 5;
                }
                else if (h == s || h == t) {
                    e = 6;
                }
                else if (h == u || h == v) {
                    e = 7;
                }
                else if (h == w || h == x) {
                    e = 8;
                }
                else if (h == y || h == z) {
                    e = 9;
                }
                else if (h == aa || h == ab) {
                    e = 10;
                }
                else if (h == ac || h == ad) {
                    e = 11;
                }
                else if (h == ae || h == af) {
                    e = 12;
                }
                else {
                    g = false;
                }
            }
            if (e > 12 || e < 1) {
                g = false;
            }
        }
        else {
            g = false;
        }
        if (g) {
            var ag = dateFromValues(f, e, d, 0, 0, 0, 0);
            var ah = Base.compareSimple(ag, this.a1);
            var ai = Base.compareSimple(ag, this.a0);
            if (ah < 0 || ai > 0) {
                this.c3();
            }
            else {
                this.c6(ag);
                this.l.am();
            }
        }
        else {
            this.c3();
        }
    };
    DatePicker.prototype.c6 = function (a) {
        var b = this.a3;
        this.a3 = a;
    };
    DatePicker.prototype.c3 = function () {
        if (this.s != null) {
            if (+(this.az) != +(dateMinValue())) {
                var a = "";
                if (this.bo == null) {
                    a = this.e.i(this.a3);
                }
                else {
                    var b = this.a3.getDate().toString();
                    var c = b;
                    if (this.a6 == "dd") {
                        if (this.a3.getDate() < 10) {
                            b = "0" + b;
                        }
                    }
                    else if (this.a6 == "ddd") {
                        switch (this.a3.getDay()) {
                            case 0:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Sunday_Short")) ? this.af.b1("Sunday_Short") : "Sun";
                                break;
                            case 1:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Monday_Short")) ? this.af.b1("Monday_Short") : "Mon";
                                break;
                            case 2:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Tuesday_Short")) ? this.af.b1("Tuesday_Short") : "Tue";
                                break;
                            case 3:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Wednesday_Short")) ? this.af.b1("Wednesday_Short") : "Wed";
                                break;
                            case 4:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Thursday_Short")) ? this.af.b1("Thursday_Short") : "Thu";
                                break;
                            case 5:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Friday_Short")) ? this.af.b1("Friday_Short") : "Fri";
                                break;
                            case 6:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Saturday_Short")) ? this.af.b1("Saturday_Short") : "Sat";
                                break;
                        }
                    }
                    else if (this.a6 == "dddd") {
                        switch (this.a3.getDay()) {
                            case 0:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Sunday_Full")) ? this.af.b1("Sunday_Full") : "Sunday";
                                break;
                            case 1:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Monday_Full")) ? this.af.b1("Monday_Full") : "Monday";
                                break;
                            case 2:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Tuesday_Full")) ? this.af.b1("Tuesday_Full") : "Tuesday";
                                break;
                            case 3:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Wednesday_Full")) ? this.af.b1("Wednesday_Full") : "Wednesday";
                                break;
                            case 4:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Thursday_Full")) ? this.af.b1("Thursday_Full") : "Thursday";
                                break;
                            case 5:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Friday_Full")) ? this.af.b1("Friday_Full") : "Friday";
                                break;
                            case 6:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Saturday_Full")) ? this.af.b1("Saturday_Full") : "Saturday";
                                break;
                        }
                    }
                    var d = dateGetMonth(this.a3).toString();
                    if (this.ba == "mm") {
                        if (dateGetMonth(this.a3) < 10) {
                            d = "0" + d;
                        }
                    }
                    else if (this.ba == "mmm") {
                        switch (dateGetMonth(this.a3)) {
                            case 1:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("January_Short")) ? this.af.b1("January_Short") : "Jan";
                                break;
                            case 2:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("February_Short")) ? this.af.b1("February_Short") : "Feb";
                                break;
                            case 3:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("March_Short")) ? this.af.b1("March_Short") : "Mar";
                                break;
                            case 4:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("April_Short")) ? this.af.b1("April_Short") : "Apr";
                                break;
                            case 5:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("May_Short")) ? this.af.b1("May_Short") : "May";
                                break;
                            case 6:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("June_Short")) ? this.af.b1("June_Short") : "Jun";
                                break;
                            case 7:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("July_Short")) ? this.af.b1("July_Short") : "Jul";
                                break;
                            case 8:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("August_Short")) ? this.af.b1("August_Short") : "Aug";
                                break;
                            case 9:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("September_Short")) ? this.af.b1("September_Short") : "Sep";
                                break;
                            case 10:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("October_Short")) ? this.af.b1("October_Short") : "Oct";
                                break;
                            case 11:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("November_Short")) ? this.af.b1("November_Short") : "Nov";
                                break;
                            case 12:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("December_Short")) ? this.af.b1("December_Short") : "Dec";
                                break;
                        }
                    }
                    else if (this.ba == "mmmm") {
                        switch (dateGetMonth(this.a3)) {
                            case 1:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("January_Full")) ? this.af.b1("January_Full") : "January";
                                break;
                            case 2:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("February_Full")) ? this.af.b1("February_Full") : "February";
                                break;
                            case 3:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("March_Full")) ? this.af.b1("March_Full") : "March";
                                break;
                            case 4:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("April_Full")) ? this.af.b1("April_Full") : "April";
                                break;
                            case 5:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("May_Full")) ? this.af.b1("May_Full") : "May";
                                break;
                            case 6:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("June_Full")) ? this.af.b1("June_Full") : "June";
                                break;
                            case 7:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("July_Full")) ? this.af.b1("July_Full") : "July";
                                break;
                            case 8:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("August_Full")) ? this.af.b1("August_Full") : "August";
                                break;
                            case 9:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("September_Full")) ? this.af.b1("September_Full") : "September";
                                break;
                            case 10:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("October_Full")) ? this.af.b1("October_Full") : "October";
                                break;
                            case 11:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("November_Full")) ? this.af.b1("November_Full") : "November";
                                break;
                            case 12:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("December_Full")) ? this.af.b1("December_Full") : "December";
                                break;
                        }
                    }
                    var e = this.a3.getFullYear().toString();
                    if (this.bd == "yy") {
                        e = e.substr(2);
                    }
                    if (this.a7 == "dmy") {
                        if (this.a6 == "ddd" || this.a6 == "dddd") {
                            a = b + this.bc + d + " " + c + this.bc + e;
                        }
                        else {
                            a = b + this.bc + d + this.bc + e;
                        }
                    }
                    else if (this.a7 == "mdy") {
                        if (this.a6 == "ddd" || this.a6 == "dddd") {
                            a = d + " " + c + this.bc + b + this.bc + e;
                        }
                        else {
                            a = d + this.bc + b + this.bc + e;
                        }
                    }
                    else if (this.a7 == "ymd") {
                        if (this.a6 == "ddd" || this.a6 == "dddd") {
                            a = e + this.bc + d + " " + c + this.bc + b;
                        }
                        else {
                            a = e + this.bc + d + this.bc + b;
                        }
                    }
                }
                this.s.cj = a;
                this.l.am();
            }
            else {
                this.s.cj = "";
                this.l.ab();
            }
        }
    };
    DatePicker.prototype.cb = function () {
        if (this.s != null) {
            this.s.cj = "";
        }
        this.a3 = dateMinValue();
        this.g.ch();
    };
    DatePicker.prototype.ce = function () {
        this.y = new Popup();
        this.l.ak(this.y);
        this.g = new Calendar();
        this.l.af(this.g);
        if (+(this.a1) != +(dateMinValue())) {
            this.g.au = this.a1;
        }
        if (+(this.a0) != +(dateMaxValue())) {
            this.g.at = this.a0;
        }
        if (+(this.a2) != +(dateMinValue())) {
            this.g.av = this.a2;
        }
        this.g.ae = this.at;
        this.g.p = this.n;
        this.g.af = this.au;
        this.g.s = this.p;
        var a = this.g;
        a.valueChanged = delegateCombine(a.valueChanged, runOn(this, this.b9));
        var b = this.g;
        b.close = delegateCombine(b.close, runOn(this, this.b8));
        this.y.appendPopupContent(this.l.m());
    };
    DatePicker.prototype.b9 = function (a, b) {
        this.a3 = b.newValue;
    };
    DatePicker.prototype.b8 = function (a) {
        if (this.y.t) {
            this.ah = true;
            this.cc();
        }
    };
    DatePicker.prototype.cj = function () {
        if (this.ah == false) {
            if (this.y.t) {
                this.cc();
            }
            else {
                this.cw();
            }
        }
        else {
            this.ah = false;
        }
    };
    DatePicker.prototype.cw = function () {
        if (this.aq) {
            return;
        }
        var a = this.l.ap();
        if (this.y != null) {
            this.y.showRelativeToExclusionRect(a, 0, 0);
        }
        this.l.an(true);
    };
    DatePicker.prototype.cc = function () {
        var _this = this;
        if (this.y != null) {
            window.setTimeout(function () { return _this.y.ao(); }, 0);
        }
        if (this.g != null) {
            this.g.cy();
        }
        this.l.an(false);
        this.ah = false;
    };
    DatePicker.prototype.focus = function (a) {
        var _this = this;
        if (a === void 0) {
            a = false;
        }
        if (this.s != null) {
            this.s.focus(a);
        }
        if (!this.y.t && this.ar == true) {
            if (this.ah == false) {
                if (this.ap == false) {
                    this.cw();
                    this.ah = true;
                    window.setTimeout(function () { return _this.ch(); }, 0);
                }
                else {
                    if (this.ar == true && this.an == false) {
                        this.cw();
                        this.ah = true;
                        window.setTimeout(function () { return _this.ch(); }, 0);
                    }
                }
            }
            else {
                this.ah = false;
            }
        }
    };
    DatePicker.prototype.ci = function () {
        this.ah = false;
    };
    DatePicker.prototype.cz = function () {
        if (this.s != null) {
            this.s.dg();
        }
    };
    DatePicker.prototype.ch = function () {
        this.g.cq();
    };
    DatePicker.prototype.cp = function () {
        var a = new GotFocusEventArgs();
        this.cr(a);
    };
    DatePicker.prototype.cq = function () {
        var a = new LostFocusEventArgs();
        this.ct(a);
    };
    DatePicker.prototype.c1 = function () {
    };
    DatePicker.prototype.c0 = function () {
    };
    DatePicker.prototype.a5 = function () {
        return this.f();
    };
    DatePicker.prototype.bl = function () {
        var a = this.f();
        return a.g();
    };
    DatePicker.prototype.f = function () {
        var a = new DatePickerVisualModelExport();
        a.b = this.d;
        a.a = this.b;
        a.e = this.y.ab();
        a.d = this.u.ia();
        a.c = this.g.bj();
        if (this.ad != null) {
            var b = this.ad;
            if (this.l != null && b.n == null) {
                var c = this.l.c;
                var d = FontUtil.getFontInfoFromString(c, b.fontString);
                b.n = d.n;
                b.d = d.d;
                b.o = d.o;
                b.q = d.q;
                b.r = d.r;
                b.s = d.s;
            }
            if (b.n != null) {
                a.h = b.n;
            }
            if (!isNaN_(b.d)) {
                a.f = b.d;
            }
            if (b.s != null) {
                a.l = b.s;
            }
            if (b.q != null) {
                a.j = b.q;
            }
            if (b.o != null) {
                a.i = b.q;
            }
        }
        return a;
    };
    DatePicker.prototype.cr = function (a) {
        if (null != this.gotFocus) {
            this.gotFocus(this, a);
        }
    };
    DatePicker.prototype.ct = function (a) {
        if (null != this.lostFocus) {
            this.lostFocus(this, a);
        }
    };
    DatePicker.prototype.cs = function (a) {
        if (null != this.keyDown) {
            this.keyDown(this, a);
        }
    };
    DatePicker.prototype.co = function (a) {
        if (null != this.changing) {
            this.changing(this, a);
        }
    };
    DatePicker.$t = markType(DatePicker, 'DatePicker', Base.$, [INotifyPropertyChanged_$type]);
    DatePicker.bg = "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z";
    DatePicker.bh = "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z";
    DatePicker.ab = null;
    return DatePicker;
}(Base));
export { DatePicker };
//# sourceMappingURL=DatePickerView_combined.js.map
